module.exports = "/images/vendor/flag-icon-css/flags/1x1/cr.svg?657d7dbcfdeb67b9324dc45f99a1e17c";